
import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Who We Are</h2>
            <p className="text-lg text-gray-700 mb-6">
              We didn't start with much — no fancy tools, no big investors, just a high school dropout with a mower, a dream, and a reason to keep going. What began as a way to make ends meet and take care of the people I love grew into something bigger — a real passion for honest work and doing things right.
            </p>
            <p className="text-lg text-gray-700 mb-6">
              Every yard we cut, every customer we meet, is a reminder of where this started: one person, one mower, and a whole lot of heart. This business was built on hard work, loyalty, and pride in every single job — because around here, it's not about where you start, it's about how much effort you put into what you do.
            </p>
            <p className="text-lg text-gray-700 mb-8">
              Today, that same determination drives us forward. We're more than just a lawn care service — we're a story about growth, grit, and taking care of people the right way!
            </p>
          </div>
          
          <div className="space-y-6">
            <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-200">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-gift-line text-green-600 text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Customer Rewards</h3>
                <p className="text-gray-600">Create an account to track your services and unlock exclusive discounts</p>
              </div>
              
              <div className="space-y-4">
                <div className="bg-green-50 rounded-lg p-4 border border-green-200">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="font-semibold text-green-800">Returning Customer Discount</h4>
                      <p className="text-sm text-green-700">Automatically applied for account holders</p>
                    </div>
                    <div className="text-2xl font-bold text-green-600">10% OFF</div>
                  </div>
                </div>
                
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="font-semibold text-blue-800">Referral Bonus</h4>
                      <p className="text-sm text-blue-700">Share your link and both save</p>
                    </div>
                    <div className="text-2xl font-bold text-blue-600">15% OFF</div>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 text-center space-y-3">
                <p className="text-sm text-gray-500">
                  *Discounts cannot be combined. Valid for residential properties only.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Link 
                    to="/register"
                    className="flex-1 bg-green-600 text-white px-4 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap text-center"
                  >
                    Create Account
                  </Link>
                  <Link 
                    to="/login"
                    className="flex-1 bg-gray-100 text-gray-700 px-4 py-3 rounded-lg font-semibold hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap text-center"
                  >
                    Sign In
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
